module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-30.4c5eca9b.jpg";